var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contracts-table',{staticClass:"tw-max-w-7xl tw-mx-auto tw-m-8",attrs:{"tableType":"Company","companyType":"Pronaht"}})}
var staticRenderFns = []

export { render, staticRenderFns }